import { Kebab as BaseKebab } from "react-ui";
import * as React from "react";
import ReactDOM from "react-dom";

import { toHtmlElementOrNull } from "../../Commons/DOM/DomHelpers";
import { IterUtils } from "../../../../../Common/IterableUtils";

export const KebabTestPageObject = (disabled: boolean | undefined, kebabRef: React.RefObject<BaseKebab>) => ({
    getType: (): string => "Kebab",
    isDisabled: (): boolean => Boolean(disabled),
    open: (): boolean => {
        if (kebabRef.current == undefined) {
            return false;
        }
        const element = toHtmlElementOrNull(ReactDOM.findDOMNode(kebabRef.current));
        if (element == undefined) {
            return false;
        }
        const tagsArray = element.querySelectorAll("span");
        if (tagsArray == undefined) {
            return false;
        }
        IterUtils.last(tagsArray)?.click();
        return true;
    },
});
